import axios from 'axios';
import jwtDecode from 'jwt-decode';

const authorizationHeader = process.env.VUE_APP_AUTHORIZATION_HEADER || 'Authorization';

const auth = {
  namespaced: true,
  state: {
    status: '',
    token: localStorage.getItem('token') || '',
    user: {},
  },
  actions: {
    async login({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit('auth_request');
        axios({ url: `${process.env.VUE_APP_API_BASE_URL}/login`, data: { email: user.email, password: user.password }, method: 'POST' }).then((resp) => {
          const token = resp.headers.authorization;
          localStorage.setItem('token', token);
          commit('auth_success', token);
          resolve(resp);
        }).catch((err) => {
          commit('auth_error');
          localStorage.removeItem('token');
          reject(err);
        });
      });
    },
    logout({ commit }) {
      return new Promise((resolve) => {
        commit('logout');
        localStorage.removeItem('token');
        delete axios.defaults.headers.common[authorizationHeader];
        resolve();
      });
    },
  },
  mutations: {
    loginSuccess(state, loggedInUser) {
      state.status.loggedIn = true;
      state.user = loggedInUser;
    },
    loginFailure(state) {
      state.status.loggedIn = false;
      state.user = null;
    },
    auth_request(state) {
      state.status = 'loading';
    },
    auth_success(state, token) {
      state.status = 'success';
      state.token = token;
    },
    auth_error(state) {
      state.status = 'error';
    },
  },
  getters: {
    isLoggedIn: (state) => {
      // Check to see if we have a token
      let unexpired = false;
      let hasToken = false;

      if (state.token) {
        hasToken = true;
        const decoded = jwtDecode(state.token);

        const currentTime = Date.now() / 1000;

        // If token isn't expired, we're good to issue the login
        if (decoded.exp > currentTime) {
          unexpired = true;
        }
      }

      return hasToken && unexpired;
    },

    authStatus: (state) => state.status,
  },
};

export default auth;
